import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {GeneralisationConfiguration} from "./generalisation-configuration";
import {GroupConfiguration} from "./group-configuration";
import {FieldOverrideConfiguration} from "./field-override-configuration";
import {TimeRangeExtensionConfiguration} from "./time-range-extension-configuration";

@JsonObject()
export class TimeSeriesFieldsConfiguration {
    /**
     * ID field name
     */
    @JsonProperty()
    declare id: string;

    /**
     * Name field name
     */
    @JsonProperty()
    declare name: string;

    /**
     * Parameter type field name
     */
    @JsonProperty()
    declare parameterType: string;

    /**
     * Station parameter type field name
     */
    @JsonProperty()
    declare stationParameter: string;

    /**
     * Data coverage from field name
     */
    @JsonProperty()
    declare from: string;

    /**
     * Data coverage to field name
     */
    @JsonProperty()
    declare to: string;

    /**
     * Unit symbol field name
     */
    @JsonProperty()
    declare unitSymbol: string;

    constructor() {}
}

@JsonObject()
export class TimeSeriesConfiguration {

    /**
     * Default time period per station parameter
     */
    @JsonProperty()
    declare defaultPeriod: { [stationParameterName: string]: string };

    /**
     * Specific fields in WISKI
     */
    @JsonProperty()
    declare fields: TimeSeriesFieldsConfiguration;

    /**
     * Mapping of WISKI fields to fields in application class
     */
    @JsonProperty()
    declare fieldMappings: string[][];

    /**
     * Override field values
     */
    @JsonProperty()
    declare overrides: FieldOverrideConfiguration[];

    /**
     * Configuration for generalizing time series data
     */
    @JsonProperty()
    declare generalisation: GeneralisationConfiguration[];

    /**
     * Rules to extend time ranges when downloading time series data.
     * It's important to extend the time range when requesting data that is aggregated.
     * e.g. precipitation sums of the last month should include all values of the whole month, not only 30 days back
     * from the current date.
     * When requesting kiwis with P1M, it's returning the last 30 days from current date, not the whole last month
     */
    @JsonProperty()
    declare timeRangeExtensions: TimeRangeExtensionConfiguration[];

    /**
     * Available groups for time series
     * Groups are used to map time series to a topic
     * Some stations has measurement parameters for multiple topics. With groups, the time series
     * are related to a topic.
     */
    @JsonProperty()
    declare groups: GroupConfiguration[];

    /**
     * Parameter types with absolute values
     */
    @JsonProperty()
    declare relativeValuesAvailable: string[];

    constructor() {}
}
